import React, { useEffect, useContext } from "react"
import { useCookies } from "react-cookie"
//import ReactDOM from "react-dom"
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Switch } from "react-router-dom"
//import Auth from "@aws-amplify/auth"
import { CookiesProvider } from "react-cookie"
import get from "lodash/get"
import isNull from "lodash/isNull"

import "./index.css"
import "bootstrap/dist/css/bootstrap.min.css"

//import { Authentication } from "views/Authentication"
import { AppLayout } from "views/AppLayout"
import { initializeApp } from "actions"
import { LANGUAGE } from "actions/constants"

import { StoreProvider, Store } from "./store"
import * as serviceWorker from "./serviceWorker"

import {Dropdown} from "react-bootstrap"
////Auth.configure({
////    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
////    region: process.env.REACT_APP_REGION,
////    userPoolId: process.env.REACT_APP_USER_POOL,
////    userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT,
////    mandatorySignIn: false, // Enforce user authentication prior to accessing AWS resources or not
////})
//
const App = () => {
    const { dispatch } = useContext(Store)

    const [cookies, setCookie] = useCookies(["language"])
    const language = get(cookies, ["language"], null)

    useEffect(() => {
        initializeApp(dispatch)
        if (isNull(language)) {
            const defaultLanguage = navigator.language
            if (defaultLanguage === "zh-CN") {
                setCookie("language", LANGUAGE.ZH, { path: "/" })
            }
            else {
                setCookie("language", LANGUAGE.EN, { path: "/" })
            }
        }
    }, [dispatch, setCookie, language])

    return (
        <BrowserRouter>
            <Switch>
                <Route component={AppLayout} />
            </Switch>
        </BrowserRouter>
    )
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <CookiesProvider>
        <StoreProvider>
            <App />
        </StoreProvider>,
    </CookiesProvider>,
//    document.getElementById("root")
)
//
//
//// If you want your app to work offline and load faster, you can change
//// unregister() to register() below. Note this comes with some pitfalls.
//// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
//ReactDOM.render(
//  <h1>Hello</h1>,
//  document.body
//);

//const domNode = document.getElementById("root");
//const root = ReactDOM.createRoot(domNode);
//root.render(<h1>Hello</h1>);
//ReactDOM.render(
//  <h1>Hello</h1>,
//  document.getElementById('content'),
//)

//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(
//<Dropdown>
//      <Dropdown.Toggle variant="success" id="dropdown-basic">
//        Dropdown Button
//      </Dropdown.Toggle>
//
//      <Dropdown.Menu>
//        <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
//        <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
//        <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
//      </Dropdown.Menu>
//    </Dropdown>
//);


//export default App;

